import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

interface ResultArray {
  id: number;
  currency_ids: Array<ResultArray>;
  //   code: string;
  //   isd_code: string;
  //   is_active: boolean;
}

interface Result {
  count: number;
  prev: null;
  current: number;
  next: number;
  total_pages: number;
  result: Array<ResultArray>;
}

interface CPCurrenciesResponse {
  jsonrpc: string;
  id: null;
  result: Result;
}

export const getCPCurrencies = (referred_by: number | null) => {
  const sessionId = getSessionId();
  const UidEmailRole = UidEmailRoleMatch();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.customer`,
      {
        params: {
          ...UidEmailRole,
          filter: `[('id', '=' , '${referred_by}')]`,
          query: "{currency_ids{id, currency_code}}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response): CPCurrenciesResponse => response.data)
    .catch((err) => err);
};
